import React from 'react'

import { TABLE_REPORTE_POR_SILOS } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export const TablaReportePorSilosView = () => <MuiTable id={TABLE_REPORTE_POR_SILOS} />
